import { StartTaskSection } from '@exam-management/task-management';

import { useQuestionCreationTaskDetails } from '../../providers';
import { StartTaskButton } from '../start-task-button';

import { getStartSectionVariant } from './utils';

export type StartSectionVariant = 'content-creator' | 'owner' | 'hidden';

export default function QuestionCreationTaskStartSection() {
  const {
    roles,
    status: { code },
  } = useQuestionCreationTaskDetails();

  const variant = getStartSectionVariant(roles, code);

  switch (variant) {
    case 'owner':
      return (
        <StartTaskSection
          title='ยังไม่มีรายการคำถาม'
          description='รอผู้รับมอบหมายเริ่มสร้างคำถาม'
        />
      );
    case 'content-creator':
      return (
        <StartTaskSection
          title='ยังไม่มีรายการคำถาม'
          description={`กดปุ่ม "เริ่มสร้างคำถาม" เพื่อเริ่มต้น \n หรือดูรายละเอียดใบสั่งงานได้ที่ Tab "Task Details"`}
          action={<StartTaskButton />}
        />
      );
    case 'hidden':
    default:
      return null;
  }
}
